module.exports = __webpack_public_path__ + "img/student-interviewing.1b30e322.jpg";